import "../../../App.css";
import React, {useState} from "react";
import {Button, Descriptions, Form, Input, Layout, message, Modal, Radio, Typography} from "antd";
import "antd/dist/reset.css";
import {useOrderId} from "../../../hooks/UseOrderId";
import {Copyable} from "../../common/Copyable";
import {PaymentType} from "../../../App";
import WrappedCard from "../../antd/WrappedCard";
import {usePostCheckoutApi} from "../../../api";

const {Content} = Layout;
const {Text, Paragraph} = Typography;

// NOTICE: GET目前是同步的，后面有可能会需要支援非同步，近来收银台后先转圈等到GET有结果

function PkBankCardMode({getCheckoutInfoData}: PaymentType) {
    const [options] = useState<Array<any>>(
        JSON.parse(getCheckoutInfoData.reserved1).map((item: any) => ({
            label: item.name,
            value: item.value,
            disabled: item.disabled
        }))
    );

    const temp = options.filter(item => item.disabled).map(item => item.label);
    const [warning] = useState<String>(
        temp.length === 0 ? '' : `* ${temp.join(' & ')} is not currently supported.`
    );

    const [providerType, setProviderType] = useState<String>('');

    const id = useOrderId();
    const [customerAccount, setCustomerAccount] = useState<String>("");
    const [customerName, setCustomerName] = useState<String>("");

    const [submitCheckout, setSubmitCheckout] = useState(false);

    // NOTICE: ant design
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const onFormValueChange = (changedValues: any, values: any) => {
        setProviderType(values.providerType);
        setCustomerAccount(values.customerAccount);
        setCustomerName(values.customerName);
    };

    // API
    const {loading, executePost} = usePostCheckoutApi(id);
    const onFormFinish = (values: any) => {
        form.validateFields().then(() => {
            showModal();
        }).catch((error) => {
            messageApi.error("Please enter valid data. ");
        });
    };

    const handleOkModal = () => {
        executePost({
            data: {
                id: id,
                providerType: providerType,
                customerAccount: customerAccount,
                customerName: customerName
            }
        })
            .then(() => {
                setSubmitCheckout(true);
            })
            .catch((error) => {
                messageApi.error("Failed:" + error?.response?.data?.title);
            });
    };

    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };
    const handleCancelModal = () => {
        setOpen(false);
    };

    const mobileNumberRegex = /^[0-9]+$/;
    const accountRegex = /^[a-zA-Z\d]+$/;
    const nameRegex = /^\S[a-zA-Z\D]+$/;

    return (
        <>
            {contextHolder}
            <Content>
                {!submitCheckout &&
                getCheckoutInfoData?.checkoutStatus !== "SUBMITTED" ? (
                    <>
                        <WrappedCard cardTitle="Information">
                            <Typography>
                                <Paragraph>
                                    <Text strong type="danger">Be sure to repay according to the prompt amount<br/>Incorrect
                                        amount will lead to recharge failure</Text>
                                </Paragraph>
                            </Typography>
                            <Descriptions bordered>
                                <Descriptions.Item label="Amount Payable">
                                    <Typography.Title
                                        copyable={{icon: <Copyable/>}}
                                        level={5}
                                        style={{margin: 0}}
                                    >
                                        {getCheckoutInfoData?.orderAmount}
                                    </Typography.Title>
                                </Descriptions.Item>
                            </Descriptions>
                        </WrappedCard>

                        <WrappedCard cardTitle="Step 1. Please input your payment information">
                            <Form
                                form={form}
                                initialValues={{providerType: providerType}}
                                onValuesChange={onFormValueChange}
                                onFinish={onFormFinish}
                            >
                                <Form.Item label="Select Payment Type " name="providerType"
                                           extra=
                                               {<label style={{color: "red"}}>{warning}</label>}
                                           rules={[{ required: true, message: 'Please select a payment type!' }]}
                                >
                                    <Radio.Group
                                        options={options}
                                        optionType="button"
                                        buttonStyle="solid"
                                    >
                                    </Radio.Group>
                                </Form.Item>

                                {(providerType === "JAZZCASH" || providerType === 'EASYPAISA') ? (
                                    <Form.Item
                                        label="Mobile Number"
                                        name="customerAccount"
                                        rules={[{
                                            required: true,
                                            pattern: mobileNumberRegex,
                                            message: 'Please enter a valid mobile number without spaces!'
                                        }]}
                                    >
                                        <Input
                                            placeholder="3345012345"
                                        />
                                    </Form.Item>
                                ) : (
                                    <Form.Item
                                        label="Account"
                                        name="customerAccount"
                                        rules={[{
                                            required: true,
                                            pattern: accountRegex,
                                            message: 'Please enter a valid account number without spaces!'
                                        }]}
                                    >
                                        <Input
                                            placeholder="6029120301123456789"
                                        />
                                    </Form.Item>
                                )}
                                <Form.Item
                                    label="Payment Account Holder Name"
                                    name="customerName"
                                    rules={[{
                                        required: true,
                                        pattern: nameRegex,
                                        message: 'Please enter a valid name!'
                                    }]}
                                >
                                    <Input
                                        placeholder="Lionel Messi"
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                    >
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Form>
                        </WrappedCard>
                        <Modal
                            open={open}
                            title={
                                <p style={{color: "red"}}>
                                    Please confirm the payment details.
                                    If you use another account to transfer, it may cause failure!
                                </p>
                            }
                            onOk={handleOkModal}
                            onCancel={handleCancelModal}
                            cancelButtonProps={{loading: loading}}
                            okButtonProps={{loading: loading}}
                            maskClosable={false}
                            closable={false}
                            okText="Confirm"
                        >
                            {(providerType === "JAZZCASH" && (
                                <>
                                    <p>Amount : {getCheckoutInfoData?.orderAmount}</p>
                                    <p>Payment : JazzCash</p>
                                    <p>Mobile number : {customerAccount}</p>
                                    <p>Name : {customerName}</p>
                                </>
                            )) || (providerType === "EASYPAISA" && (
                                <>
                                    <p>Amount : {getCheckoutInfoData?.orderAmount}</p>
                                    <p>Payment : EasyPaisa</p>
                                    <p>Mobile number : {customerAccount}</p>
                                    <p>Name : {customerName}</p>
                                </>
                            )) || (
                                <>
                                    <p>Amount : {getCheckoutInfoData?.orderAmount}</p>
                                    <p>Payment : Bank Account</p>
                                    <p>Bank Account : {customerAccount}</p>
                                    <p>Name : {customerName}</p>
                                </>
                            )}
                        </Modal>
                    </>
                ) : (
                    <>
                        <WrappedCard cardTitle="Information">
                            <Typography>
                                <Paragraph>
                                    <Text strong type="danger">Be sure to repay according to the prompt amount<br/>Incorrect
                                        amount will lead to recharge failure</Text>
                                </Paragraph>
                            </Typography>
                            <Descriptions bordered>
                                <Descriptions.Item label="Amount Payable">
                                    <Typography.Title
                                        copyable={{icon: <Copyable/>}}
                                        level={5}
                                        style={{margin: 0}}
                                    >
                                        {getCheckoutInfoData?.orderAmount}
                                    </Typography.Title>
                                </Descriptions.Item>
                            </Descriptions>
                        </WrappedCard>

                        <WrappedCard cardTitle="Step 2. Copy Bank details and transfer money to the account">
                            <Typography>
                                <Paragraph>
                                    <Text strong type="danger">When you fail to repay with ep or jazz, please use bank
                                        transfer</Text>
                                </Paragraph>
                                <Paragraph>
                                    <Text strong type="danger" style={{fontSize: 20}}>{warning}</Text>
                                </Paragraph>
                            </Typography>
                            <Descriptions bordered>
                                <Descriptions.Item label="Account No">
                                    <Typography.Title
                                        copyable={{icon: <Copyable/>}}
                                        level={5}
                                        style={{margin: 0}}
                                    >
                                        {getCheckoutInfoData?.receiverAccount}
                                    </Typography.Title>
                                </Descriptions.Item>
                                <Descriptions.Item label="Bank Name">
                                    <Typography.Title
                                        copyable={{icon: <Copyable/>}}
                                        level={5}
                                        style={{margin: 0}}
                                    >
                                        {getCheckoutInfoData?.receiverBank}
                                    </Typography.Title>
                                </Descriptions.Item>
                            </Descriptions>
                        </WrappedCard>
                    </>
                )}
            </Content>
        </>
    );
}

export default PkBankCardMode;
